import type { InviteIntegrationSource, InviteViewPhase } from "./inviteTypes";

const PRIXI_PHASE_MAP: Partial<Record<InviteViewPhase, InviteViewPhase>> = {
  connect: "prixi_connect",
  connect_error: "prixi_connect_error",
  meta_page_id: "prixi_meta_page_id",
  meta_podcast_select: "prixi_meta_podcast_select",
  meta_mapping: "prixi_meta_mapping",
  connecting: "prixi_connecting",
  success: "prixi_success",
  already_connected: "prixi_already_connected",
  disconnected: "prixi_disconnected",
  expired: "prixi_expired",
  unavailable: "prixi_unavailable",
};

export function mapPodscopePhaseToPrixi(phase: InviteViewPhase): InviteViewPhase {
  return PRIXI_PHASE_MAP[phase] ?? phase;
}

const BASE_FROM_PRIXI_PHASE_MAP: Partial<Record<InviteViewPhase, InviteViewPhase>> = {
  prixi_connect: "connect",
  prixi_connect_error: "connect_error",
  prixi_meta_page_id: "meta_page_id",
  prixi_meta_podcast_select: "meta_podcast_select",
  prixi_meta_mapping: "meta_mapping",
  prixi_connecting: "connecting",
  prixi_success: "success",
  prixi_already_connected: "already_connected",
  prixi_disconnected: "disconnected",
  prixi_expired: "expired",
  prixi_unavailable: "unavailable",
};

export function mapPrixiPhaseToBase(phase: InviteViewPhase): InviteViewPhase {
  if (!isPrixiInvitePhase(phase)) return phase;
  return BASE_FROM_PRIXI_PHASE_MAP[phase] ?? phase;
}

export function isPrixiInvitePhase(phase: InviteViewPhase): boolean {
  return phase.startsWith("prixi_");
}

export function shouldShowPrixiInviteChrome(
  integrationSource: InviteIntegrationSource | undefined,
  viewPhase: InviteViewPhase,
): boolean {
  return integrationSource === "prixi" || isPrixiInvitePhase(viewPhase);
}

export function isInviteSuccessPhase(phase: InviteViewPhase): boolean {
  return phase === "success" || phase === "prixi_success";
}

export function isInviteAlreadyConnectedPhase(phase: InviteViewPhase): boolean {
  return phase === "already_connected" || phase === "prixi_already_connected";
}

export function isInviteDisconnectedPhase(phase: InviteViewPhase): boolean {
  return phase === "disconnected" || phase === "prixi_disconnected";
}

export function isInviteConnectLifecyclePhase(phase: InviteViewPhase): boolean {
  return (
    phase === "connect" ||
    phase === "connect_error" ||
    phase === "meta_page_id" ||
    phase === "meta_podcast_select" ||
    phase === "meta_mapping" ||
    phase === "connecting" ||
    phase === "prixi_connect" ||
    phase === "prixi_connect_error" ||
    phase === "prixi_meta_page_id" ||
    phase === "prixi_meta_podcast_select" ||
    phase === "prixi_meta_mapping" ||
    phase === "prixi_connecting"
  );
}

export function isInviteInactivePhase(phase: InviteViewPhase): boolean {
  return (
    phase === "expired" ||
    phase === "unavailable" ||
    phase === "prixi_expired" ||
    phase === "prixi_unavailable"
  );
}

export function isInviteTerminalHeroPhase(phase: InviteViewPhase): boolean {
  return (
    isInviteSuccessPhase(phase) ||
    isInviteAlreadyConnectedPhase(phase) ||
    isInviteDisconnectedPhase(phase)
  );
}
